module.exports = __webpack_public_path__ + "img/iap-uam-mobile.58304a49.gif";